/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the order addresses
 * @returns {OrderAddressEntity | null} The `order` address that has been selected from the store
 */
const ordersAddressesSelector = createSelector(ordersSelector, (orders) => orders.addresses);

export default ordersAddressesSelector;
